import React from "react";
import InputWrapper from "./input-wrapper";

const InputTextFieldV2 = ({
  value = "",
  isDisabled = false,
  onValueChange,
  placeholder = "",
  paddingClass,
  inputClass = "",
  PrefixComponent,
  onBlur = () => {},
}: {
  value: string | number;
  isDisabled?: boolean;
  onValueChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  paddingClass: string;
  inputClass?: string;
  PrefixComponent?: () => JSX.Element | null;
  onBlur?: () => void;
}) => {
  const [isFocusOn, setIsFocusOn] = React.useState(false);

  const onFocus = () => {
    setIsFocusOn(true);
  };

  const handleBlur = () => {
    setIsFocusOn(false);
    onBlur();
  };

  return (
    <InputWrapper
      focus={isFocusOn}
      isDisabled={isDisabled}
      paddingClass={paddingClass}
    >
      {PrefixComponent && <PrefixComponent />}
      <input
        value={value}
        onChange={onValueChange}
        disabled={isDisabled}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={handleBlur}
        className={`${inputClass} ${isDisabled ? "cursor-not-allowed" : ""}`}
      />
    </InputWrapper>
  );
};

export default InputTextFieldV2;
